import{a as t}from"./chunk-2HA4XQFN.js";var n=t((u,r=0)=>Math.round((u+Number.EPSILON)*10**r)/10**r,"round");export{n as a};
